import { render, staticRenderFns } from "./rClinicalNotes.vue?vue&type=template&id=1ca869f0&"
import script from "./rClinicalNotes.vue?vue&type=script&lang=js&"
export * from "./rClinicalNotes.vue?vue&type=script&lang=js&"
import style0 from "./rClinicalNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports